import { render, staticRenderFns } from "./BoardCommand.vue?vue&type=template&id=17b5c4f1&scoped=true"
import script from "./BoardCommand.vue?vue&type=script&lang=js"
export * from "./BoardCommand.vue?vue&type=script&lang=js"
import style0 from "./BoardCommand.vue?vue&type=style&index=0&id=17b5c4f1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b5c4f1",
  null
  
)

export default component.exports